import React, { useState } from 'react';
import {
  ComposableMap,
  Geographies,
  Geography
} from 'react-simple-maps';

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const USAMap = ({ onStateClick, selectedState, interactive = true }) => {
  const [hoverPR, setHoverPR] = useState(false);
  const safeSelectedState = selectedState || null;
  const isPuertoRicoSelected = safeSelectedState === "Puerto Rico";
  
  // Determinar el color de Puerto Rico
  const getPuertoRicoFill = () => {
    if (isPuertoRicoSelected) return "#33424A";
    if (interactive && hoverPR) return "#41A3A7";
    return "#e9ecef";
  };
  
  return (
    <ComposableMap 
      projection="geoAlbersUsa" 
      className="map-svg"
      width={800}
      height={500}
    >
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies.map((geo) => {
            const stateName = geo.properties.name;
            const isSelected = safeSelectedState === stateName;
            const isClickable = interactive && typeof onStateClick === 'function';
            
            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                onClick={isClickable ? () => onStateClick(stateName) : undefined}
                className={`state-path ${isSelected ? 'selected' : ''}`}
                style={{
                  default: {
                    fill: isSelected ? "#33424A" : "#e9ecef",
                    stroke: "#dee2e6",
                    strokeWidth: 1,
                    outline: "none",
                  },
                  hover: {
                    fill: interactive ? (isSelected ? "#33424A" : "#41A3A7") : (isSelected ? "#33424A" : "#e9ecef"),
                    outline: "none",
                  },
                  pressed: {
                    fill: "#33424A",
                    outline: "none",
                  },
                }}
              />
            );
          })
        }
      </Geographies>
      
      {/* Puerto Rico como elemento SVG adicional */}
      <g>
        <path
          d="M 680 420 L 720 420 L 730 425 L 728 432 L 720 435 L 680 433 Z"
          fill={getPuertoRicoFill()}
          stroke="#dee2e6"
          strokeWidth={1}
          onClick={interactive && typeof onStateClick === 'function' ? () => onStateClick("Puerto Rico") : undefined}
          onMouseEnter={interactive ? () => setHoverPR(true) : undefined}
          onMouseLeave={interactive ? () => setHoverPR(false) : undefined}
          style={{ 
            cursor: interactive && typeof onStateClick === 'function' ? "pointer" : "default",
            transition: "fill 0.2s ease"
          }}
          className={`puerto-rico-path ${isPuertoRicoSelected ? 'selected' : ''}`}
        />
      </g>
    </ComposableMap>
  );
};

export default USAMap;
